import classNames from "classnames";
import * as _ from "lodash";

interface Options {
    svg: Pick<React.SVGProps<SVGCircleElement>, "cx" | "cy" | "r" | "stroke" | "strokeWidth" | "fill">;
    style?: React.CSSProperties;
    className?: string;
}

const defaultOptions = {
    svg: {
        cx: "14",
        cy: "14",
        r: "10",
        stroke: "#ffffff",
        strokeWidth: "3",
        fill: "none",
    },
    style: {
        width: "30px",
        height: "30px",
    },
    className: "",
} satisfies Options;

interface LoaderProps {
    options?: Partial<Options>;
}

export const CircularLoader = ({ options: propsOptions = {} }: LoaderProps) => {
    const options = _.merge({}, defaultOptions, propsOptions);
    return (
        <svg
            className={classNames("circularLoader-svg", options.className)}
            style={options.style}
        >
            <circle
                className="circularLoader-circle"
                cx={options.svg.cx}
                cy={options.svg.cy}
                r={options.svg.r}
                stroke={options.svg.stroke}
                strokeWidth={options.svg.strokeWidth}
                fill={options.svg.fill}
            ></circle>
        </svg>
    );
};
